export const APPOINTCHART_PENDING = "APPOINTCHART_PENDING";
export const APPOINTCHART_DATA = "APPOINTCHART_DATA";
export const APPOINTCHART_REJECTED = "APPOINTCHART_REJECTED";
export const CUSTCHART_PENDING = "CUSTCHART_PENDING";
export const CUSTCHART_DATA = "CUSTCHART_DATA";
export const CUSTCHART_REJECTED = "CUSTCHART_REJECTED";
